import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

interface StepbarStore {
  selectedStep: string | null
  stepWithError: string | null
  setSelectedStep: (step: string | null) => void
  setStepWithError: (stepWithError: string | null) => void
}

export const useStepbarStore = create<StepbarStore>()(
  devtools(
    (set) => ({
      stepWithError: null,
      setStepWithError: (stepWithError) => {
        set({ stepWithError }, false, 'setHasError')
      },
      selectedStep: null,
      setSelectedStep: (step) => {
        set({ selectedStep: step }, false, 'setSelectedStep')
      }
    }),
    { name: 'useStepbarStore' }
  )
)
